import { useLocation as useLocationReactRouter } from "react-router";

export const useLocation = () => {
  const location = useLocationReactRouter();
  let pathname = location.pathname;
  if (location.pathname === "/" || !location.pathname) {
    pathname = location.search;
  }
  location.pathname = pathname || "/";
  location.search = "";
  return location;
};

export const useLocationSplitter = () => {
  const location = useLocationReactRouter();
  if (location.pathname === "/" || !location.pathname) {
    return "frontpage";
  }
  return "contentpage";
};
